export let industries = (state = industries, action) => {
    switch (action.type) {
        case "REQUEST_INDUSTRIES":
            return {};
        case "RECEIVE_INDUSTRIES":
            return action.industries;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/industries.js